<script>
  import { t } from '../i18n/i18n'
  import {location, link} from 'svelte-spa-router'
  export let current = ''

  let crumbs = $location.split('/').reduce((crumb_list, crumb, i, arr) => {
    if (!crumb) {
      return crumb_list
    }
    let path = arr.slice(0, i).join('/')
    let new_crumb = [crumb, `${path}/${crumb}`]
    crumb_list.push(new_crumb)
    return crumb_list
  }, [])
</script>

<style>
  nav {
    display: flex;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  nav > *  {
    text-transform: capitalize;
  }
</style>

<nav>
  {#each crumbs as crumb, index}
    {#if crumbs.length === index + 1 && current}
      <span>{current}</span>
    {:else if crumb}
      <a href={`${crumb[1]}/`} use:link>{$t[crumb[0]]}</a> {crumbs.length !== index + 1 ? '>' : ''}
    {/if}
  {/each}
</nav>
